var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    { staticClass: "flex items-baseline", class: _vm.optionClasses },
    [
      _c("span", { staticClass: "pr-2" }, [_vm._v(_vm._s(_vm.option.name))]),
      _c("span", { staticClass: "flex flex-wrap text-xs" }, [
        _c("span", [
          _c("span", { staticClass: "whitespace-wrap" }, [
            _vm._v(_vm._s(_vm.option.startDate)),
          ]),
          _c("span", { staticClass: "px-1" }, [_vm._v("-")]),
        ]),
        _c("span", { staticClass: "whitespace-wrap" }, [
          _vm._v(_vm._s(_vm.option.endDate)),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }